__webpack_require__.p =(function() {
    const l = /^(localhost|localhost:[0-9]{2,4}|.*\.netlify\.app|local\.dev\.clover\.com|192\..+)$/;
    const c = {"dev":{"host":"https://dev.cloverstatic.com"},"prod":{"host":"https://cloverstatic.com"}}; 
    const p = '/web/apps/web-checkout/b38c992/';

    if (l.test(window.location.hostname)) return p;

    const [e, r, et] = window.location.hostname.split('.');

    if (e === 'sandbox') return c['prod'].host + p;
    else if (r === 'dev') return c['dev'].host + p;

    let t = r.length === 2 ? et : r;
    t = t === 'clover' ? 'prod' : t;

    return c[t === 'prod' ? 'prod' : 'dev'].host + p;
  })()